import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import { setStore } from '../services/authService';

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

setStore(store);

export { store };